import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { faClock } from '@fortawesome/pro-duotone-svg-icons';
import { BrickCategory } from '../../../../samwebDescription/samweb/brickCategoryType';
import { AnalogClock } from 'analog-clock/clock';
import { BasicBrickComponent } from '../../basic-brick-component';

@Component({
   selector: 'samweb-clock-brick',
   templateUrl: './clock-brick.component.html',
   styleUrls: ['./clock-brick.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
@SamwebBrick({
   brickDefinitionId: 'clockBrick',
   brickTitleTranslationKey: 'brick.brick_definitions.clock.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.clock.description',
   brickIcon: faClock,
   minColWidth: 10,
   minRowHeight: 10,
   brickCategory: BrickCategory.DEBUG,
})
export class ClockBrickComponent extends BasicBrickComponent implements OnInit, AfterViewInit {
   @ViewChild('clockHost')
   public clockHost: ElementRef;

   public brickInstanceId: string;

   ngOnInit() {}

   ngAfterViewInit(): void {
      const clock = new AnalogClock();
      this.clockHost.nativeElement.appendChild(clock);
   }
}
